import React from 'react';
import { useNavigate } from 'react-router-dom';
import ChatGPTHero from '../components/chatgpt/ChatGPTHero';
import OptimizedChatGPTPlans from '../components/OptimizedChatGPTPlans';
import ChatGPTSteps from '../components/chatgpt/ChatGPTSteps';
import ChatGPTStats from '../components/chatgpt/ChatGPTStats';
import ChatGPTFAQ from '../components/chatgpt/ChatGPTFAQ';
import ChatGPTCTA from '../components/chatgpt/ChatGPTCTA';

const ChatGPTPlus = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/product-detail');
  };

  const handleViewPlans = () => {
    const plansSection = document.getElementById('chatgpt-plans');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <ChatGPTHero 
        onGetStarted={handleGetStarted}
        onViewPlans={handleViewPlans}
      />
      <div id="chatgpt-plans">
        <OptimizedChatGPTPlans onSelectPlan={handleGetStarted} />
      </div>
      <ChatGPTSteps />
      <ChatGPTStats />
      <ChatGPTFAQ />
      <ChatGPTCTA onGetStarted={handleGetStarted} />
    </div>
  );
};

export default ChatGPTPlus;